import styles from './EmptyState.module.css'

export interface EmptyStateProps {
  heading: string
  description: string
  ctaLabel: string
  ctaTo: string
}

export function EmptyState({ heading, description, ctaLabel, ctaTo }: EmptyStateProps) {
  return (
    <div className={styles.root}>
      <div className={styles.illustration} aria-hidden="true">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
          <rect x="8" y="16" width="48" height="36" rx="4" stroke="currentColor" strokeWidth="2" fill="none" />
          <path d="M20 28h24M20 36h16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          <path d="M32 4v8M28 8l4-4 4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
      <h2 className={styles.heading}>{heading}</h2>
      <p className={styles.description}>{description}</p>
      <a href={ctaTo} className={styles.cta}>{ctaLabel}</a>
    </div>
  )
}
